import { customStyled, Flex, Box } from '@mafc/trolly';

export const NewCreditCardItem = customStyled(Flex)((props: any) => ({
  alignItems: 'center',
}));

export const TitleWrapper = customStyled(Box)(({ theme }) => ({
  fontSize: theme.fontSizes[2],
  marginLeft: '12px',
  color: theme.colors.black,
}));

export const Title = customStyled(Box)(({ theme }) => ({
  fontWeight: theme.fontWeights[8],
}));
